import { FAQsPage } from "@/pages/information/faqs";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/faqs")({
  component: FAQsPage,
});
